import Footer from "@/base/Footer";
import usePresentModeContext from "@/view/utils/usePresentModeContext";

const ViewPageFooter = () => {
  const { isVideoPresentModeActive } = usePresentModeContext();

  if (isVideoPresentModeActive) return null;

  return <Footer />;
};

export default ViewPageFooter;
